import React from "react";
import { Button, Typography, Modal, Card } from "@mui/material";

const PrivacyPolicyComponent = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="privacy-policy-title">
      <Card
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          maxWidth: "600px",
          width: "90%",
          textAlign: "justify",
        }}
      >
        <Typography id="privacy-policy-title" variant="h6" gutterBottom>
          Aviso de Privacidad
        </Typography>
        <Typography variant="body1" gutterBottom>
          Este sitio respeta y protege su privacidad. La información personal
          proporcionada en este sitio será utilizada exclusivamente para fines
          de contacto y no será compartida con terceros sin su consentimiento.
          Además, utilizamos medidas de seguridad como captcha y encriptación
          para proteger sus datos.
        </Typography>
        <Typography variant="body1" gutterBottom>
          Puede ejercer su derecho a acceder, rectificar o eliminar su
          información poniéndose en contacto a través de nuestro formulario.
        </Typography>
        <Typography variant="body2" color="primary" gutterBottom>
          Para más información sobre sus derechos de privacidad consulte el sitio oficial del{" "}
          <a
            href="https://www.inai.org.mx"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none", color: "#1976d2" }}
          >
            INAI
          </a>
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={{ mt: 2 }}
        >
          Cerrar
        </Button>
      </Card>
    </Modal>
  );
};

export default PrivacyPolicyComponent;